import { OrganizationUserRole } from "../userOrganizationRoles";

export enum OrganizationSortValue {
    NAME_ASC = "NAME_ASC",
    NAME_DESC = "NAME_DESC",
    CREATED_AT_ASC = "CREATED_AT_ASC",
    CREATED_AT_DESC = "CREATED_AT_DESC",
    ONBOARDING_COMPLETED_AT_ASC = "ONBOARDING_COMPLETED_AT_ASC",
    ONBOARDING_COMPLETED_AT_DESC = "ONBOARDING_COMPLETED_AT_DESC",
}

export interface OrganizationAdminMemberUser {
    id: number;
    preferredName: string | null;
    email: string | null;
}

export interface OrganizationAdminMemberAssignment {
    role: OrganizationUserRole;
    user: OrganizationAdminMemberUser;
}

export interface OrganizationAdminClientWorkspace {
    id: string;
    name: string;
}

export interface OrganizationAdminWorkspaceAssignment {
    workspace: OrganizationAdminClientWorkspace;
    billingOwnership: boolean;
}

export interface OrganizationAdminItem {
    id: string;
    name: string;
    createdAt: Date;
    onboardingCompletedAt: Date | null;
    userAssignments: OrganizationAdminMemberAssignment[];
    workspaceAssignments: OrganizationAdminWorkspaceAssignment[];
}

export interface OrganizationsAdminResult {
    data: OrganizationAdminItem[];
    count: number;
    page: number;
    pageCount: number;
}
